import { Link } from "react-router-dom";
import { categories } from "../../../mocks/categories";
import { works } from "../../../mocks/works";

const counts: Record<string, number> = {};
works.forEach((w) => {
  counts[w.categoryId] = (counts[w.categoryId] ?? 0) + 1;
});

export default function Categories() {
  return (
    <section className="border-y border-background-300/60 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <div className="mx-auto max-w-xl text-center">
          <span className="text-xs font-semibold tracking-widest text-accent-500">DIRECTORY</span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            按目录浏览同人分类
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-400">
            从热血战斗到清水治愈，从长篇连载到完结佳作，按主题分类快速定位你想看的同人作品。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((c) => (
            <Link
              key={c.id}
              to={`/works?cat=${c.id}`}
              className="group flex flex-col rounded-lg border border-background-300/60 bg-background-200/40 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/50 hover:bg-background-200"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500/15 text-primary-300 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${c.icon} text-xl`} />
                </span>
                <span className="text-[11px] font-medium tracking-widest text-foreground-400">{c.en}</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950 group-hover:text-primary-300">
                {c.name}
              </h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-400">{c.desc}</p>
              <span className="mt-4 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-book-2-line" />
                收录 {counts[c.id] ?? 0}+ 部
                <i className="ri-arrow-right-line ml-auto transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}